module.exports = __webpack_public_path__ + "static/media/ic_graphic_referral_details_payout@3x.60eecaff.png";